import { render, staticRenderFns } from "./CoproffExport.vue?vue&type=template&id=4e2e1431&scoped=true"
import script from "./CoproffExport.vue?vue&type=script&lang=js"
export * from "./CoproffExport.vue?vue&type=script&lang=js"
import style0 from "./CoproffExport.vue?vue&type=style&index=0&id=4e2e1431&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2e1431",
  null
  
)

export default component.exports